import { SettingsMaterialDefinitionsDashboardContainer } from 'modules/settings/pods/settings-materials/settings-material-definitions-dashboard/settings-material-definitions-dashboard.container';

export const SettingsMaterialDefinitionsScene = () => <SettingsMaterialDefinitionsDashboardContainer />;

export default SettingsMaterialDefinitionsScene;
